import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import { renderCols } from './helpers/renders';
import type { TGridComponent } from './models';

export const Grid: FC<React.PropsWithChildren<TGridComponent>> = ({
    alignment = false,
    children,
    className,
    classNames = {},
    colAutoWidth = false,
    collapse = false,
    columnsWidth = null,
    flexDirection = 'row',
    justify = 'center',
    paddingTop = false,
    styles,
    vertical = false,
    wrap = false,
    dataTestId = 'grid',
    columnsMargin = 25,
    ...rest
}) => {
    const hasAlignment = !!alignment;
    const isDefaultAlignment = typeof alignment === 'boolean' && hasAlignment;
    const isCustomAlignment = !isDefaultAlignment && hasAlignment;

    return (
        <div
            className={cn(
                styles.grid,
                { [styles.column]: flexDirection === 'column' },
                { [styles.paddingTop]: paddingTop },
                // @ts-ignore
                styles[`${justify}Justify`],
                { [styles.defaultAlignment]: isDefaultAlignment },
                {
                    // @ts-ignore
                    [styles[`${alignment}AlignItems`]]: isCustomAlignment,
                },
                { [styles.vertical]: vertical },
                { [styles.wrap]: wrap },
                classNames.grid,
                className
            )}
            data-test-id={dataTestId}
            {...rest}
        >
            {renderCols(
                children,
                {
                    colAutoWidth,
                    collapse,
                    columnsWidth,
                    columnsMargin,
                    vertical,
                },
                classNames,
                styles
            )}
        </div>
    );
};
